// @flow
import { getBasePath } from "../constants/Settings";

(function x() {
  __webpack_public_path__ = `${getBasePath()}/`; // NOSONAR
})();
